// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"abaec022","327":"7f79afa7","400":"abaec022","411":"abaec022","441":"de20b890","489":"4d236300","653":"b188ee8f","941":"6a0bcd52","957":"abaec022"}[chunkId] + ".chunk.css";
};